import { render, staticRenderFns } from "./CustomerCustomerReportSummary.vue?vue&type=template&id=5d913261&scoped=true"
import script from "./CustomerCustomerReportSummary.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerReportSummary.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomerReportSummary.vue?vue&type=style&index=0&id=5d913261&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d913261",
  null
  
)

export default component.exports